import { brandConfiguration } from "@/brands/config";
import { buildUrlPatterns } from "./buildUrlPatterns";
import { urlParser } from "./urlParser";
export const getClassifiedIdFromURL = (pathname) => {
    const { urlPatterns } = brandConfiguration;
    const urlPatternsWithRoutes = buildUrlPatterns(urlPatterns);
    return urlParser(urlPatternsWithRoutes, pathname);
};
